import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  ActivityStatBox,
  IBLSpinLoader,
  PopularCourse,
  SkillLeaderBoardBox,
  StatTimeSpentBox,
} from '../../../components';
import { useProfileActivity } from '../../../hooks';
import './ActivityViewContent.css';
import { AppDataContext } from '../../../utils';

export const ActivityViewContent = ({ username, userId }) => {
  const [
    timeSpentGraphData,
    timeSpentGraphDataLoaded,
    userActivityData,
    userActivityDataLoaded,
    mostPopularCourseData,
    mostPopularCourseDataLoaded,
    userProgramsTotal,
    userProgramsTotalLoaded,
    userCredentialsTotal,
    userCredentialsTotalLoaded,
    userPathwaysAndResourcesTotal,
    userPathwaysAndResourcesTotalLoaded,
    userCoursesTotal,
    userCoursesTotalLoaded,
    totalUserSkills,
    totalUserSkillsLoaded,
    userCourses,
    userCoursesLoaded,
    skillPoints,
    skillPointsLoaded,
  ] = useProfileActivity(username, userId);
  const {appData, tenantMetaData} = useContext(AppDataContext) ?? {}
  const { t } = useTranslation('library');
  const [leaderboardDisplayEnabled,setLeaderboardDisplayEnabled] = useState(false);
  const stats = [
    {
      label: t('Points'),
      value: Math.round(skillPoints),
      loaded: skillPointsLoaded,
    },
    {
      label: t('Skills'),
      value: totalUserSkills,
      loaded: totalUserSkillsLoaded,
    },
    {
      label: t('Credentials'),
      value: userCredentialsTotal,
      loaded: userCredentialsTotalLoaded,
    },
    {
      label: t('Courses'),
      value: userCoursesTotal,
      loaded: userCoursesTotalLoaded,
    },
    {
      label: t('Programs'),
      value: userProgramsTotal,
      loaded: userProgramsTotalLoaded,
    },
    {
      label: t('Pathways'),
      value: userPathwaysAndResourcesTotal?.pathways,
      loaded: userPathwaysAndResourcesTotalLoaded,
    },
    {
      label: t('Resources'),
      value: userPathwaysAndResourcesTotal?.totalResources,
      loaded: userPathwaysAndResourcesTotalLoaded,
    },
    {
      label: t('Assessments'),
      value: userActivityData?.data?.total_assessments,
      loaded: userActivityDataLoaded,
    },
    {
      label: t('Videos'),
      value: userActivityData?.data?.total_videos,
      loaded: userActivityDataLoaded,
    },
  ];

  const renderStat = ({ label, value, loaded }, index) => (
    <div key={index} className={`flex_col_6 border_l`}>
      {!loaded ? (
        <IBLSpinLoader size={25} />
      ) : (
        <div>
          <div className="profile_stat_h">{value}</div>
          <div className="profile_stat_ex">{label}</div>
        </div>
      )}
    </div>
  );

  useEffect(() => {
    let displayLeaderboard = tenantMetaData?.enable_skills_leaderboard_display
    if(displayLeaderboard && appData?.userMetaData?.public_metadata?.enable_skills_leaderboard_display){
      displayLeaderboard=true
    }
    setLeaderboardDisplayEnabled(displayLeaderboard)
  }, [tenantMetaData, appData?.userMetaData?.public_metadata]);

  return (
    <span>
      <div className="ov_panel active" data-name="ov">
        <div className="div-block-404">
          <div className="div-block-481">
            <div className="overview_stats">{stats.map(renderStat)}</div>
          </div>
        </div>
        <div className="div-block-424">
          <div className="div-block-499">
            <StatTimeSpentBox
              timeSpentGraphData={timeSpentGraphData}
              timeSpentGraphDataLoaded={timeSpentGraphDataLoaded}
            />
          </div>
          <div className="div-block-414">
            <ActivityStatBox
              userActivityData={userActivityData}
              userActivityDataLoaded={userActivityDataLoaded}
            />
            <PopularCourse
              username={username}
              userCourses={userCourses}
              userCoursesLoaded={userCoursesLoaded}
              mostPopularCourseData={mostPopularCourseData}
              mostPopularCourseDataLoaded={mostPopularCourseDataLoaded}
            />
          </div>
        </div>
        {
          leaderboardDisplayEnabled && (
            <div className="div-block-383">
              <SkillLeaderBoardBox
                percentile={skillPoints}
                percentileLoaded={skillPointsLoaded}
              />
            </div>
          )
        }
      </div>
    </span>
  );
};
